import { render } from "./totalchamados.vue?vue&type=template&id=c658e644&scoped=true"
import script from "./totalchamados.vue?vue&type=script&lang=js"
export * from "./totalchamados.vue?vue&type=script&lang=js"

import "./totalchamados.vue?vue&type=style&index=0&id=c658e644&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c658e644"]])

export default __exports__